export default __webpack_public_path__ + "images/buddy-dry4L.jpg";